import isEqual from 'lodash.isequal'

/**
 * This function is used to navigate to a new location in different MFEs.
 * It checks if the new location is different from the current location before navigating,
 * that is necessary to prevent unnecessary re-renders and potential infinite loops.
 * @param {Object} params.nextLocation - The location that is used when calling the function, this is where the navigation should go.
 * @param {Object} params.history - The history object from react-router-dom.
 */
export const onNavigate = ({ nextLocation, history }) => {
    if (!areLocationsEqual(nextLocation, history.location)) {
        history.push(nextLocation)
    }
}

const areLocationsEqual = (location1, location2) => {
    const {
        pathname: pathname1,
        hash: hash1,
        search: search1,
        state: state1,
    } = location1
    const {
        pathname: pathname2,
        hash: hash2,
        search: search2,
        state: state2,
    } = location2
    return (
        pathname1 === pathname2 &&
        hash1 === hash2 &&
        search1 === search2 &&
        isEqual(state1, state2)
    )
}
